/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Drive_UnavailableInputs */

const en_google_drive_unavailable = /** @type {(inputs: Google_Drive_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Drive is not available yet. Please try again later.`)
};

const es_google_drive_unavailable = /** @type {(inputs: Google_Drive_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Drive aún no está disponible. Vuelve a intentarlo más tarde.`)
};

/**
* | output |
* | --- |
* | "Google Drive is not available yet. Please try again later." |
*
* @param {Google_Drive_UnavailableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const google_drive_unavailable = /** @type {((inputs?: Google_Drive_UnavailableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Drive_UnavailableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_google_drive_unavailable(inputs)
	return en_google_drive_unavailable(inputs)
});